import { render, staticRenderFns } from "./PostPreviewModal.vue?vue&type=template&id=5dcf0a13&"
import script from "./PostPreviewModal.vue?vue&type=script&lang=js&"
export * from "./PostPreviewModal.vue?vue&type=script&lang=js&"
import style0 from "./PostPreviewModal.vue?vue&type=style&index=0&id=5dcf0a13&prod&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports